module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group slider-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.lng.duration) + "\n                "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dtype),
      expression: "dtype"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.dtype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.setTypeDuration]
    }
  }, [_c('option', {
    attrs: {
      "value": "month"
    }
  }, [_vm._v("month")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "week"
    }
  }, [_vm._v("week")])])]), _vm._v(" "), _c('div', {
    staticClass: "slider-group-box"
  }, [_c('div', {
    staticClass: "slider-input-box"
  }, [_c('input', {
    ref: "dfrom",
    staticClass: "slider-group-box__input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.duration.value[0]
    }
  }), _vm._v(" "), _c('span', [_vm._v(" - ")]), _vm._v(" "), _c('input', {
    ref: "dto",
    staticClass: "slider-group-box__input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.duration.value[1]
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-slider",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handlerSend.apply(null, arguments)
      }
    }
  }, [_vm._v("Set")])]), _vm._v(" "), _c('vue-slider', _vm._b({
    ref: "sliderEl",
    on: {
      "drag-end": _vm.stopDrag
    },
    model: {
      value: (_vm.duration.value),
      callback: function($$v) {
        _vm.$set(_vm.duration, "value", $$v)
      },
      expression: "duration.value"
    }
  }, 'vue-slider', _vm.duration, false))], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataRequest.permanent),
      expression: "dataRequest.permanent"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox-id"
    },
    domProps: {
      "checked": Array.isArray(_vm.dataRequest.permanent) ? _vm._i(_vm.dataRequest.permanent, null) > -1 : (_vm.dataRequest.permanent)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.dataRequest.permanent,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.dataRequest, "permanent", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.dataRequest, "permanent", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.dataRequest, "permanent", $$c)
        }
      }, _vm.sendRequest]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "checkbox",
    attrs: {
      "for": "checkbox-id"
    }
  }, [_vm._v("Permanent contract")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/PhpstormProjects/e-crewing/~/vue-loader/lib/template-compiler.js?id=data-v-8430c904!C:/PhpstormProjects/e-crewing/~/vue-loader/lib/selector.js?type=template&index=0!./vue/frontfilter/components/Duration.vue
// module id = 51
// module chunks = 0 1